import { Pipe, PipeTransform } from '@angular/core';
import { ValueType } from '@deprecated/api-interfaces';
import { Observable, from } from 'rxjs';
import { DataConversionService } from '../services';

@Pipe({
  name: 'spxDataConversion',
})
export class SpxDataConversionPipe implements PipeTransform {
  /**
   * Converts value from sourceUnit(from Sensor/SensorType) and targetUnit(from UserSettings)
   * Use it like this:
   * <p> {{ 3 | spxDataConversion: ValueType.TEMPERATURE: 'F' | async  }}</p>
   *
   * @param dataConversionService
   */
  constructor(private dataConversionService: DataConversionService) {}

  transform(value: number, valueType: ValueType, sourceUnit: string, sensorPrecision?: number): Observable<number> {
    return from(
      this.dataConversionService.convertValue(value, {
        sourceUnit,
        valueType,
        sensorPrecision,
      }),
    );
  }
}
